import { useEffect, useRef } from "react";

const overlayLabels = [
  { label: "HVAC", desc: "İklimlendirme", top: "18%", left: "12%" },
  { label: "PCS", desc: "Güç Dönüştürücü", top: "30%", left: "72%" },
  { label: "SCADA", desc: "Kontrol Sistemi", top: "55%", left: "20%" },
  { label: "Yangın Güvenliği", desc: "FM200 Sistem", top: "60%", left: "65%" },
];

const techSpecs = [
  { icon: "ri-door-line", label: "Metal Sac Kapı", desc: "3mm galvaniz çelik, çift kilitli güvenlik kapısı" },
  { icon: "ri-stack-line", label: "Mineral Yün Panel", desc: "100mm yalıtım, yangın sınıfı A1, ses yalıtımı" },
  { icon: "ri-layout-bottom-line", label: "Ağır Hizmet Zemin", desc: "C30 beton, 5 ton/m² yük kapasitesi" },
  { icon: "ri-shield-check-line", label: "IP55 Koruma", desc: "Toz ve su sızdırmazlık, dış ortam dayanımı" },
];

export default function TechnicalSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".tech-label").forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = "1";
                (el as HTMLElement).style.transform = "scale(1)";
              }, i * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="teknik-yapi" ref={sectionRef} className="py-24 md:py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Header */}
        <div className="mb-12">
          <span className="text-[#A66A3F] text-xs font-semibold tracking-[0.2em] uppercase">
            Sistem Mimarisi
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2B2B2B] mt-3">
            Teknik Yapı
          </h2>
        </div>

        {/* Big Image with Overlay Labels */}
        <div className="relative w-full overflow-hidden border border-gray-100 mb-0">
          <img
            src="https://static.readdy.ai/image/ecb21a4bf5131aa1974d0073377f0964/a89f374a69ac34772ee70a19f792d9d5.png"
            alt="AKSESS BESS Teknik Yapı"
            className="w-full h-[400px] md:h-[560px] object-cover object-center"
          />
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-[#2B2B2B]/30" />

          {/* Overlay Labels */}
          {overlayLabels.map((item) => (
            <div
              key={item.label}
              className="tech-label absolute bg-white/95 border border-gray-200 px-3 py-2 hidden md:block"
              style={{
                top: item.top,
                left: item.left,
                opacity: 0,
                transform: "scale(0.85)",
                transition: "opacity 0.5s ease, transform 0.5s ease",
              }}
            >
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-[#A66A3F] rounded-full flex-shrink-0" />
                <p className="text-xs font-bold text-[#2B2B2B] whitespace-nowrap">{item.label}</p>
              </div>
              <p className="text-[10px] text-[#6A6A6A] mt-0.5 pl-3.5">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Tech Specs Bar */}
        <div className="bg-[#2B2B2B] grid grid-cols-2 md:grid-cols-4">
          {techSpecs.map((spec, i) => (
            <div
              key={spec.label}
              className={`px-6 py-6 ${i < techSpecs.length - 1 ? "border-r border-white/10" : ""}`}
            >
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className={`${spec.icon} text-xl text-[#A66A3F]`} />
              </div>
              <p className="text-white text-sm font-semibold mb-1">{spec.label}</p>
              <p className="text-white/50 text-xs leading-relaxed">{spec.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
